/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { dataExportsDeleteRoute } from "../funcs/dataExportsDeleteRoute.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteDataExportRouteRequest,
  DeleteDataExportRouteSecurity,
} from "../models/operations/deletedataexportroute.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DeleteDataExportRouteMutationVariables = {
  request: DeleteDataExportRouteRequest;
  security?: DeleteDataExportRouteSecurity | undefined;
  options?: RequestOptions;
};

export type DeleteDataExportRouteMutationData = void;

export type DeleteDataExportRouteMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteRoute dataExports
 *
 * @remarks
 * Delete a data source's export route configuration.
 */
export function useDeleteDataExportRouteMutation(
  options?: MutationHookOptions<
    DeleteDataExportRouteMutationData,
    DeleteDataExportRouteMutationError,
    DeleteDataExportRouteMutationVariables
  >,
): UseMutationResult<
  DeleteDataExportRouteMutationData,
  DeleteDataExportRouteMutationError,
  DeleteDataExportRouteMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDeleteDataExportRouteMutation(client, options),
    ...options,
  });
}

export function mutationKeyDeleteDataExportRoute(): MutationKey {
  return ["@gram/client", "dataExports", "deleteRoute"];
}

export function buildDeleteDataExportRouteMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DeleteDataExportRouteMutationVariables,
  ) => Promise<DeleteDataExportRouteMutationData>;
} {
  return {
    mutationKey: mutationKeyDeleteDataExportRoute(),
    mutationFn: function deleteDataExportRouteMutationFn({
      request,
      security,
      options,
    }): Promise<DeleteDataExportRouteMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(dataExportsDeleteRoute(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
